import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery('#bigSlider').slick({
    ...options,
    dots: false,
    slidesToShow: 1.6,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: jQuery('.big-slider-prev'),
    nextArrow: jQuery('.big-slider-next'),
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                centerPadding: '200px',
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerPadding: '50px',
            }
        },
        {
            breakpoint: 501,
            settings: {
                centerPadding: '30px',
            }
        }
    ]
});
